module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Warning', [_c('p', [_vm._v("Пока вы не являетесь участником ни одной из команд.")]), _c('OpenForm', {
    attrs: {
      "mainText": "Нажмите + чтобы создать новый запрос",
      "helpText": "Опубликованный запрос позволит участвовать в наставнической программе."
    },
    on: {
      "openForm": _vm.click
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68327ad2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/emptyteams/MentoringEmptyTeams.vue
// module id = 87b39809da78b0b1f85f
// module chunks = 89